// extracted by mini-css-extract-plugin
export default {"PostCreate":"qg_a bhm_qt bhm_a bhm_w bhm_ea"};